import { Button, DialogActions } from '@mui/material';
import { FC } from 'react';
import { useKeyPress } from '../../hooks/useKeyPress';

type Props = Readonly<{
	primaryButtonText: string;
	handlePrimaryButtonClick: () => void;
	cancelButtonText: string;
	handleCancelButtonClick: () => void;
	isDelete?: boolean;
	disablePrimaryButton?: boolean;
}>;

export const ModalActions: FC<Props> = ({
	primaryButtonText,
	cancelButtonText,
	handlePrimaryButtonClick,
	handleCancelButtonClick,
	isDelete = false,
	disablePrimaryButton = false,
}) => {
	const { setIsPressed } = useKeyPress(handlePrimaryButtonClick);
	return (
		<DialogActions
			sx={
				isDelete
					? {
							justifyContent: 'center',
							alignItems: 'stretch',
							gap: 2.5,
							px: 4,
							pb: 4,
							mt: 3,
							pt: 0,
						}
					: {
							justifyContent: 'flex-end',
							alignItems: 'center',
							width: '100%',
							gap: 1,
							p: 2.5,
						}
			}
		>
			<Button
				onClick={() => handleCancelButtonClick()}
				sx={isDelete ? { flex: 1 } : {}}
				size={isDelete ? 'large' : 'medium'}
				variant={isDelete ? 'outlined' : 'text'}
				color={'secondary'}
			>
				{cancelButtonText}
			</Button>
			<Button
				onClick={() => handlePrimaryButtonClick()}
				onKeyDown={() => setIsPressed(true)}
				sx={isDelete ? { flex: 1, ml: '0 !important', px: '22px' } : {}}
				size={isDelete ? 'large' : 'medium'}
				color={isDelete ? 'error' : 'primary'}
				variant={'contained'}
				disabled={disablePrimaryButton}
			>
				{primaryButtonText}
			</Button>
		</DialogActions>
	);
};
